module.exports = __webpack_public_path__ + "media/8.47a055a4.wav";